import { Config, createForm, FormApi, FormState } from 'final-form';
import arrayMutators from 'final-form-arrays';
import setFieldData from 'final-form-set-field-data';
import setFieldTouched from 'final-form-set-field-touched';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ['validate', 'onSubmit', 'initialValues'],
    template: require('./form.html'),
})
export class Form extends Vue {
    public formState: FormState = null as any;
    public initialValues: Config['initialValues'];
    public validate: Config['validate'];
    public onSubmit: Config['onSubmit'];
    public form: FormApi = null as any;

    private unsubscribe;

    public created() {
        this.form = createForm({
            initialValues: this.initialValues,
            mutators: { setFieldTouched, setFieldData, ...arrayMutators },
            onSubmit: this.onSubmit,
            validate: this.validate,
        });

        this.unsubscribe = this.form.subscribe(
            state => {
                this.formState = state;
                this.$emit('change', state.values);
            },
            {
                active: true,
                dirty: true,
                dirtySinceLastSubmit: true,
                error: true,
                errors: true,
                hasSubmitErrors: true,
                hasValidationErrors: true,
                initialValues: true,
                invalid: true,
                pristine: true,
                submitError: true,
                submitErrors: true,
                submitFailed: true,
                submitSucceeded: true,
                submitting: true,
                touched: true,
                valid: true,
                validating: true,
                values: true,
                visited: true,
            },
        );
    }

    public beforeDestroy = () => {
        this.unsubscribe();
    };

    public handleSubmit(event: Event) {
        event.preventDefault();
        this.form.submit();
    }
}
